import React, { useState } from "react";
import { Typography, Button, notification, Flex, Col, Row, DatePicker } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import useRoleCheck from "utilities/hooks/roleCheck";
import axiosInstance from "utilities/axios";
import dayjs from "dayjs";

const { Title, Text } = Typography;

const RegionName = ({ region, onChange }) => {
  const navigate = useNavigate();
  const { hasPermission } = useRoleCheck();

  const [editing, setEditing] = useState(false);
  const [endDate, setEndDate] = useState(region.endDate);

  const changeRegionName = (e) => {
    if (e !== region.regionName) {
      axiosInstance
        .patch(`regions/${region.regionCode}`, {
          regionName: e,
        })
        .then((response) => {
          notification.success({
            message: "Region Name Updated",
            description: "Region Name has been successfully updated",
          });
          onChange();
        })
        .catch((error) => {
          notification.error({
            message: "Failed to Update Region Name",
            description: error.response.data.error,
          });
        });
    }
  };

  const changeRegionCode = (e) => {
    if (e !== region.regionCode) {
      axiosInstance
        .patch(`regions/${region.regionCode}`, {
          regionCode: e,
        })
        .then((response) => {
          notification.success({
            message: "Region Code Updated",
            description: "Region Code has been successfully updated",
          });
          navigate(`/regions/${e}`);
        })
        .catch((error) => {
          notification.error({
            message: "Failed to Update Region Code",
            description: error.response.data.error,
          });
        });
    }
  };

  const changeEndDate = (date) => {
    if (date.format("YYYY-MM-DD") !== region.endDate) {
      axiosInstance
        .patch(`regions/${region.regionCode}`, {
          endDate: date ? date.format("YYYY-MM-DD") : null,
        })
        .then(() => {
          notification.success({
            message: "End Date Updated",
            description: "End Date has been successfully updated",
          });
          setEndDate(date ? date.format("YYYY-MM-DD") : null);
          onChange();
        })
        .catch((error) => {
          notification.error({
            message: "Failed to Update End Date",
            description: error.response.data.error,
          });
        });
    }
  }

  if (!region) return null;

  return (
    <>
      <Flex align="center">
        <Row>
          <Col span={24}>
            <Title
              editable={
                hasPermission(
                  ["Admin.Manage", "Sales.Exec"],
                  ["Sales.Exec"],
                  region?.regionCode,
                  false
                )
                  ? {
                      icon: <Button type="text" icon={<EditOutlined />} />,
                      onChange: changeRegionCode,
                      tooltip: "Edit Region Code",
                    }
                  : false
              }
              level={2}
              style={{ margin: 0, marginRight: 24, height: 48 }}
            >
              {region.regionCode}
            </Title>
          </Col>
          <Col span={24}>
            <Text type="secondary">Region Code</Text>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Title
              editable={
                hasPermission(
                  ["Admin.Manage", "Admin.Basic"],
                  ["Sales.Exec"],
                  region?.regionCode,
                  false
                )
                  ? {
                      icon: <Button type="text" icon={<EditOutlined />} />,
                      onChange: changeRegionName,
                      tooltip: "Edit Region Name",
                    }
                  : false
              }
              level={2}
              style={{ margin: 0, height: 48 }}
            >
              {region.regionName}
            </Title>
          </Col>
          <Col span={24}>
            <Text type="secondary">Region Name</Text>
          </Col>
        </Row>
        {region.temporary && (
          <Row>
            {editing ? (
              <Col span={24}>
                <DatePicker
                  value={endDate ? dayjs(endDate) : null}
                  onChange={changeEndDate}
                  onBlur={() => setEditing(false)}
                />
              </Col>
            ) : (
              <Col span={24} style={{ display: "flex", alignItems: "flex-end" }}>
                <Title level={2} style={{ margin: 0, height: 48 }}>
                  {endDate ? endDate : "No End Date"}
                </Title>
                <Button
                  type="text"
                  icon={<EditOutlined />}
                  style={{ marginBottom: 0 }}
                  onClick={() => setEditing(true)}
                />
              </Col>
            )}
              <Col span={24}>
                <Text type="secondary">End Date</Text>
              </Col>
            </Row>
          )}
      </Flex>
    </>
  );
};

export default RegionName;
